export default __webpack_public_path__ + "assets/64cdba48fb69caae61185190f96776e2.png";